import _default from './Label';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Label/index.js
// module id = 137
// module chunks = 0